/**
 * ============================================================================
 * DEEP DIVE TAB — "Deep Dive: DCR Periodical Aggregation" content.
 * ============================================================================
 *
 * OWNERSHIP: SDE 3 (Phase 3 / Week 5 in the Pippin timeline).
 *
 * SCOPE:
 * - Full DCR-level drilldown table (AG Grid): one row per DCR, columns for
 *   metric values per week, with row-level conditional formatting.
 * - ECharts waterfall chart: rework breakdown by domain.
 * - Only available when granularity = 'row-level' (week window ≤ 12 weeks).
 *   When 'weekly-summary' — show an info box explaining why it's disabled.
 *
 * LATER TABS (same pattern): "Deep Dive: DCR Periodical Aggregation (S...)",
 * "Dive Deep DCR", "Dive Deep: DCR - SO" — each will be a config variation
 * of this component or a separate DeepDive* component as needed.
 */

import React from 'react';
import Box from '@amzn/awsui-components-core/box';

export const DeepDiveTab: React.FC = () => {
  return (
    <Box padding="l">
      {/* TODO(Phase 3):
          1. AG Grid with full DCR-level rows (one per dcrId), from getMetrics
             dcrData — same query/cache as MetricTableSection.
          2. Column grouping: Historical | Current | Forward, same as
             MetricTableSection.
          3. Rate-value colouring via MetricValueCell (goal-based text colour). */}
      <Box variant="p" color="text-body-secondary">
        Deep Dive: DCR Periodical Aggregation — implementation pending (Phase 3)
      </Box>
    </Box>
  );
};
